import { Link } from "@quintype/components";
import { connect } from "react-redux";
import React from 'react';
import omit from 'lodash/omit';

import "../header-template/header-grid.module.css";

function MenuLink(props) {
  const clazz = props.item.isExternalLink ? "a" : Link;

  return React.createElement(clazz, Object.assign({
    href: props.item.completeUrl,
  }, omit(props, ["item"])), props.item.title);
}

class MenuBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeChild: null
    };
    this.toggleSubmenu = this.toggleSubmenu.bind(this);
  }

  toggleSubmenu(e) {
    e.stopPropagation();
    e.preventDefault();
    const currentChild = Number(e.target.dataset.id);
    this.setState(function(prevState) {
      return { activeChild: prevState.activeChild === currentChild ? null : currentChild }
    })
  }

  render() {
    const {className, menu, sidebar, hasMoreItems, count, languageDirection = 'left', closeAll} = this.props;
    return (
      <ul data-menu="true" className={className} styleName="top-level-menu">
      {menu.slice(0, count).map((item, index) => {
        if (item.children.length && item['menu-group-slug'] !== 'secondary-menu') {
          return (
            <li className={`menu-item has-child ${index === this.state.activeChild ? "submenu-open" : "submenu-close"}`} key={`${item['id']}${index}`}>
              {(item['item-type'] === 'placeholder') ? <div>{ item.title }</div> : (<Link callback={closeAll} href={ item.completeUrl } >{ item.title }</Link>)}
              {
                sidebar &&
                  <svg className="arrow" onClick={this.toggleSubmenu} data-id={index} id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>chevron-down</title><polygon points="12 15.71 6.65 10.35 7.35 9.65 12 14.29 16.65 9.65 17.35 10.35 12 15.71" fill="currentColor" fillRule="evenodd"/></svg>
              }
              <ul data-submenu="true" className={`sub-menu ${index === this.state.activeChild ? "open" : "close"} ${languageDirection === 'right' ? 'sub-menu-rtl' : ''}`}>
                {item.children.map((child, index)=> {
                  return (
                    <li className="sub-menu-item" key={`${child['id']}${index}`}>
                      <MenuLink callback={closeAll} item={child}/>
                    </li>
                  )
                })}
              </ul>
            </li>
          )
        }

        return (
          <li className="menu-item" key={`${item['id']}${index}`}>
            {(item['item-type'] === 'placeholder') ? <span>{ item.title }</span> : <MenuLink callback={closeAll} item={item}/>}
          </li>
        );
      })}
      {
        hasMoreItems &&
        <li className="more menu-item has-child">
          More
          <ul className="sub-menu">
            {
              menu.slice(count).map((item, index) =>
                <li className="sub-menu-item" key={`${item['id']}${index}`}>
                  <MenuLink callback={closeAll} item={item}/>
                </li>
              )
            }
          </ul>
        </li>
      }
      </ul>
    )
  }
}

const mapStateToProps = state => {
  return {
    isSidebarVisible: state.header.isSidebarVisible
  }
};

export const Menu = connect(mapStateToProps)(MenuBase);